import React, {Component} from 'react';
import Storage from 'react-native-storage';
import Cookies from 'universal-cookie';
import AppConstants from '../Constants/AppConstants';
var CryptoJS = require('crypto-js');
const cookies = new Cookies();

const storage = new Storage({
  size: 1000,
  storageBackend: window.localStorage, // Use localStorage instead of AsyncStorage
  defaultExpires: 100000 * 3600 * 24,
  enableCache: true,
  sync: {
    // we'll talk about the details later.
  },
});

export function clearStorage() {
  storage.clearMap();
}

export function getCurrentUser(callback) {
  const bearerAtStart = AppConstants.BearerAuthorization;
  const finish = value => {
    if (typeof callback === 'function') callback(value);
  };

  storage
    .getAllDataForKey('adminKey')
    .then(ids => {
      if (!ids?.[0]) {
        finish('');
        return;
      }

      try {
        const bytes = CryptoJS.AES.decrypt(ids[0], AppConstants.privateKey);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        if (!originalText) {
          finish('');
          return;
        }

        if (AppConstants.BearerAuthorization === bearerAtStart) {
          AppConstants.BearerAuthorization = originalText;
        }
        finish(AppConstants.BearerAuthorization || originalText);
      } catch (error) {
        // Ignore stale or malformed local credentials. The auth shell will
        // handle the missing bearer token without crashing the application.
        AppConstants.BearerAuthorization = '';
        finish('');
      }
    })
    .catch(() => {
      finish('');
    });
}

export function getValue(key, callbackValue) {
  storage.getAllDataForKey(key).then(ids => {
    callbackValue(ids);
  });
}

export function saveUserData(key, data, id) {
  storage.save({key: key, id: id, data: data});
}

export function saveAdminData(key, data, id) {
  var ciphertext = CryptoJS.AES.encrypt(
    data,
    AppConstants.privateKey,
  ).toString();
  return storage.save({
    key: key,
    id: id,
    data: ciphertext,
  });
}

export function saveCookies(key, data, maxAge = 86400) {
  cookies.set(key, data, {
    path: '/',
    maxAge,
    domain: AppConstants.cookies_domain_name,
  });
  return true;
}

export function clearCookies(key) {
  cookies.remove(key, {
    path: '/',
    maxAge: 86400,
    domain: AppConstants.cookies_domain_name,
  });
  return true;
}

export function getCookiesValue(key) {
  if (AppConstants.isDevelopment) {
    return 'dev';
  } else {
    let value = cookies.get(key);
    if (value == undefined) {
      return 'production';
    } else {
      return value;
    }
  }
}

export function getMemberCookiesValue(key) {
  let value = cookies.get(key);
  if (value == undefined) {
    return false;
  } else {
    return value;
  }
}

export function getValuesFromCookies(key) {
  let value = cookies.get(key);
  if (value == undefined) {
    return 'en';
  } else {
    return value;
  }
}

// Encrypt data with AES
export function encryptDataWithAES(data) {
  return CryptoJS.AES.encrypt(data, AppConstants.ckPrivateKey).toString();
}
export function templateEncryptDataWithAES(data) {
  return CryptoJS.AES.encrypt(data, AppConstants.ckPrivateKey).toString();
}
